export default __webpack_public_path__ + "media/images/svg/bone-decor-8bae499776571675e58181e3c0e6fe03.svg";